import React, { Component } from "react";

class TopNav extends Component {
  setNav(name) {
    if (!this.props.currentState.name) return "";
    if (this.props.currentState.name.toLowerCase() === name.toLowerCase())
      return "top-nav-active";
    else return "";
  }

  render() {
    return (
      <div
        className={`top-nav  ${
          this.props.currentState.name === "INTRO" ? "hidden" : ""
        }`}
      >
        <ul className="top-nav-list w-list-unstyled clickable">
          <li
            className={`top-nav-item ${this.setNav("OVERVIEW")}`}
            onClick={() => this.props.GoToState("OVERVIEW", true)}
          >
            Overview
          </li>
          <li
            className={`top-nav-item ${this.setNav("BUILDING")}`}
            onClick={() => this.props.GoToState("BUILDING", true)}
          >
            Building
          </li>
          <li
            className={`top-nav-item ${this.setNav("AMENITIES")}`}
            onClick={() => this.props.GoToState("AMENITIES", true)}
          >
            Amenities
          </li>
          <li
            className={`top-nav-item ${this.setNav("CONNECTIONS")}`}
            onClick={() => this.props.GoToState("CONNECTIONS", true)}
          >
            Connections
          </li>
          <li
            className={`top-nav-item ${this.setNav("CONTACT")}`}
            onClick={() => this.props.GoToState("CONTACT", true)}
          >
            Contact
          </li>
        </ul>
      </div>
    );
  }
}

export default TopNav;
